import { Validator } from '@vista-digital/validator';
import { defaultFilmRuntimeConfig, filmRuntimeConfigValidator } from './config';
import { defaultFilmRuntimeDisplayText, filmRuntimeDisplayTextValidator } from './display-text';
export const defaultFilmRuntimeProps = {
    displayText: defaultFilmRuntimeDisplayText,
    config: defaultFilmRuntimeConfig
};
export const filmRuntimePropsValidator = Validator.object({
    displayText: filmRuntimeDisplayTextValidator,
    config: filmRuntimeConfigValidator
});
